export const generatePermissionList = (data) => {
  if (!data || !Array.isArray(data) || data.length < 1) return [];

  const res = [];

  for (let idx = 0; idx < data.length; idx++) {
    const item = data[idx];
    if (!item) continue;

    if (item.function_id && res.indexOf(item.function_id) < 0) {
      res.push(item.function_id);
    }

    if (item.permission_id && res.indexOf(item.permission_id) < 0) {
      res.push(item.permission_id);
    }
  }

  return res;
};
